import { css } from '@emotion/css';
import { Font, FontWeight } from 'src/styles';

export const cancelButton = css`
  ${Font.lg}
  ${FontWeight.semibold}
`;
